import { useEffect } from 'react';
import REQ, { combineReqs } from 'utils/REQ';
import { PRODUCER_HOME_PAGE_VIEW } from 'utils/mixpanel';
import usePageView from '_common/hooks/usePageView';
import { RootState } from '../../../store';
import {
  useAppDispatch,
  useAppSelector
} from '../../../_common/hooks/reduxHooks';
import { updateOnboardingHistory } from '../../../_common/reducers/auth';
import ProducerMessagesSection from './producer-messages-section/ProducerMessagesSection';
import ProducerSalesSection from './producer-sales-section/ProducerSalesSection';
import ProducerProductsSection from './producer-product-section/ProducerProductsSection';
import { Page } from '@components/page';
import { CommonNavbar } from '@components/navbar';

const ProducerLandingPage = () => {
  const dispatch = useAppDispatch();
  const { producerId } = useAppSelector(({ auth }: RootState) => {
    return {
      producerId: auth._id
    };
  });

  usePageView(PRODUCER_HOME_PAGE_VIEW);

  useEffect(() => {
    dispatch(updateOnboardingHistory(producerId));
  }, []);

  return (
    <Page header={<CommonNavbar showLogo showActionsOnMobile />}>
      <ProducerMessagesSection />
      <ProducerSalesSection />
      <ProducerProductsSection />
    </Page>
  );
};

const ProducerLandingPageFetcher = () => {
  const { req } = useAppSelector(
    ({
      orders: { req: ordersReq },
      producerProducts: { req: producerProductsReq }
    }) => {
      return {
        req: combineReqs([ordersReq, producerProductsReq])
      };
    }
  );

  if (req !== REQ.SUCCESS) {
    return <Page.Status req={req} />;
  }

  return <ProducerLandingPage />;
};

export default ProducerLandingPageFetcher;
